import React from 'react';

/**
 * If there are no existing messages, render the intro message provided
 * by the job chat config
 */
export const useAddIntroMessage = (messages, initialAriMessageObj, setLocalMsgs) => {
	React.useEffect(
		() => {
			if (!messages.length && initialAriMessageObj) {
				setLocalMsgs(() => [initialAriMessageObj]);
			}
		},
		[messages]
	);
};
